import gql from 'graphql-tag';

import client from '../graphqlAPI';

const SEARCH_EVENT_QUERY = gql`
  query searchEvents($search: String!) {
    searchEvents(search: $search) {
      eventSlugName
    }
  }
`;

const getSearchEvents = async (search) => {
  try {
    const result = await client
      .query({
        query: SEARCH_EVENT_QUERY,
        errorPolicy: 'all',
        fetchPolicy: 'no-cache',
        variables: { search },
        fetchResults: true,
        pollInterva: 300000,
      })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });
    const {
      data: { searchEvents },
    } = result;

    if (searchEvents) {
      return searchEvents;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: searchArtistSets`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: searchArtistSets Error: ${error}`);
    return null;
  }
};

export default getSearchEvents;
